(function() {
  function initCarousels() {
    document.querySelectorAll('[data-carousel]:not([data-initialized])').forEach(function(carousel) {
      carousel.setAttribute('data-initialized', '1');
      var slides = carousel.querySelectorAll('.vp-product__carousel-slide');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var card = carousel.closest('.vp-product__card');
      var gallery = carousel.closest('.vp-product__gallery');
      if (!slides.length || slides.length <= 1) return;

      // Elevate gallery above card-link for touch/click interception
      gallery.style.zIndex = '4';

      var track = carousel.querySelector('[data-carousel-track]');
      var total = slides.length;
      var transitioning = false;
      var pendingReturn = false;

      // Clone first and last slides for infinite loop
      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[total - 1].cloneNode(true);
      firstClone.setAttribute('data-clone', '1');
      lastClone.setAttribute('data-clone', '1');
      track.appendChild(firstClone);
      track.insertBefore(lastClone, track.firstChild);

      // Position starts at 1 (real first slide, after cloned last)
      var pos = 1;
      track.style.transition = 'none';
      track.style.transform = 'translateX(-100%)';
      // Force reflow then restore transition
      track.offsetHeight;
      track.style.transition = '';

      function slideTo(p, animate) {
        if (transitioning) return;
        if (animate === false) {
          track.style.transition = 'none';
        } else {
          track.style.transition = 'transform 0.35s ease';
          transitioning = true;
        }
        pos = p;
        track.style.transform = 'translateX(-' + (pos * 100) + '%)';
        if (animate !== false) {
          setTimeout(function() {
            transitioning = false;
            // Jump to real slide if on a clone
            if (pos === 0) {
              track.style.transition = 'none';
              pos = total;
              track.style.transform = 'translateX(-' + (pos * 100) + '%)';
            } else if (pos === total + 1) {
              track.style.transition = 'none';
              pos = 1;
              track.style.transform = 'translateX(-' + (pos * 100) + '%)';
            }
            // If mouse already left during this transition, slide back now
            if (pendingReturn) {
              pendingReturn = false;
              slideTo(1);
            }
          }, 360);
        }
      }

      // Chevron buttons
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          slideTo(pos - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          slideTo(pos + 1);
        });
      }

      // Click on gallery (desktop) — navigate to product page
      gallery.addEventListener('click', function(e) {
        // Don't navigate if clicking chevron buttons
        if (e.target.closest('[data-carousel-prev], [data-carousel-next]')) return;
        var link = card && card.querySelector('.vp-product__card-link');
        if (link) window.location.href = link.href;
      });

      // Desktop hover
      if (card) {
        card.addEventListener('mouseenter', function() {
          if (window.innerWidth < 750 || total <= 1) return;
          pendingReturn = false;
          slideTo(pos + 1);
        });
        card.addEventListener('mouseleave', function() {
          if (window.innerWidth < 750) return;
          if (transitioning) {
            // Can't slide yet — schedule return for when transition ends
            pendingReturn = true;
          } else {
            slideTo(1);
          }
        });
      }

      // Touch swipe on gallery
      var touchStartX = 0;
      var touchStartY = 0;
      var swiping = false;
      var galleryWidth = 0;

      gallery.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        swiping = false;
        galleryWidth = gallery.offsetWidth;
        track.style.transition = 'none';
      }, { passive: true });

      gallery.addEventListener('touchmove', function(e) {
        var diffX = e.touches[0].clientX - touchStartX;
        var diffY = Math.abs(e.touches[0].clientY - touchStartY);
        if (Math.abs(diffX) > diffY && Math.abs(diffX) > 10) {
          swiping = true;
          e.preventDefault();
          var baseOffset = -(pos * 100);
          var dragPercent = (diffX / galleryWidth) * 100;
          track.style.transform = 'translateX(' + (baseOffset + dragPercent) + '%)';
        }
      }, { passive: false });

      gallery.addEventListener('touchend', function(e) {
        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var diffX = touchStartX - endX;
        var diffY = touchStartY - endY;
        if (swiping && Math.abs(diffX) > 30) {
          slideTo(diffX > 0 ? pos + 1 : pos - 1);
        } else if (swiping) {
          slideTo(pos);
        } else if (Math.abs(diffX) < 10 && Math.abs(diffY) < 10) {
          if (card) window.location.href = card.querySelector('.vp-product__card-link').href;
        }
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
})();
